var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportarExcel }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Excel")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-primary btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.cerrar }
            },
            [
              _c("i", { staticClass: "fa fa-times" }),
              _c("span", [_vm._v("Cerrar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", { attrs: { for: "hoy" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "hoy",
                    value: "H"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "H")
                    }
                  }
                }),
                _c("span", [_vm._v("Hoy")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ayer" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "ayer",
                    value: "A"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "A")
                    }
                  }
                }),
                _c("span", [_vm._v("Ayer")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "personalizado" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "personalizado",
                    value: "P"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipo_fecha", "P")
                    }
                  }
                }),
                _c("span", [_vm._v("Personalizado")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("date-picker", {
                      attrs: {
                        disabled: _vm.form.tipo_fecha !== "P",
                        stretch: "",
                        type: "date",
                        format: "dd-MM-yyyy",
                        id: "desde"
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")]),
                    _vm._v(" "),
                    _vm.errores.desde
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.errores.desde[0]))])]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("date-picker", {
                      attrs: {
                        disabled: _vm.form.tipo_fecha !== "P",
                        stretch: "",
                        type: "date",
                        format: "dd-MM-yyyy",
                        id: "hasta"
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")]),
                    _vm._v(" "),
                    _vm.errores.hasta
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.errores.hasta[0]))])]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.conciliaciones, function(conciliacion, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(conciliacion.fecha_conciliacion) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(conciliacion.observacion) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(conciliacion.nombre_usuario_cierre) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(conciliacion.nombre_vendedor) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.moneyFormat(conciliacion.total_margenes)) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.moneyFormat(conciliacion.saldo_pendiente)
                          ) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.moneyFormat(conciliacion.total_comision)) +
                          "\n                     "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-danger btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.anularCierre(conciliacion)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm.conciliaciones.length === 0
                  ? _c("tr", [_vm._m(4)])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _vm._m(6),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.moneyFormat(_vm.margenTotal)) +
                      "\n                     "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.moneyFormat(_vm.saldoTotal)) +
                      "\n                     "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.moneyFormat(_vm.comisionTotal)) +
                      "\n                     "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta de Cierre de Comisiones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha de conciliación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Usuario de cierre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Vendedor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total de margen")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total de comisión")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "9" } }, [
      _c("strong", [
        _vm._v(
          "\n                           No se ha encontrado resultados.\n                        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Margen total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comisión total")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce60fecc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce60fecc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cierre-comisiones/ConsultaCierreComisiones.vue
// module id = 607
// module chunks = 0